import apiClient from '../ApiClient';

interface Country {
  country_id: number;
  nationality: string;
  country_name: string;
}

interface CountryOption {
  value: number;
  label: string;
}

class ContentMgt {
  async getCountries(): Promise<CountryOption[] | { error: any; status: boolean }> {
    try {
      const res = await apiClient.get<{ data: Country[] }>('countries');
      const modified = res.data.data.map((i) => ({
        value: i.country_id,
        label: i.nationality,
      }));
      return modified;
    } catch (error) {
      return { error: error, status: false };
    }
  }

  //...
}

const contentMgt = new ContentMgt();
export default contentMgt;
